export default __webpack_public_path__ + "static/media/gallery-3.701756de.jpg";